export default __webpack_public_path__ + "static/media/gallery-3.455d22c1.jpg";